import { Box } from '@wix/design-system';
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';

import { TRootState } from '../common/reducers';
import { selectIsAiEnabled } from '../common/selectors/chat';
import { logger } from '../util/logger';
import { AttachmentsDropzone } from './components/AttachmentsDropzone';
import { Chat } from './components/Chat';
import { DeferredActionEmitter } from './components/DeferredActionEmitter';
import { DocumentVisibilityListener } from './components/DocumentVisibilityListener';
import { ErrorMessages } from './components/ErrorMessages';
import { Field } from './components/Field';
import { Field as FieldNext } from './components/FieldNext';

interface Props {
  isAiEnabled: boolean;
}

class Chatbot extends Component<Props> {
  private chatbotRef = createRef<HTMLDivElement>();

  componentDidCatch(error: Error, callParams) {
    logger.error({
      error,
      message: '<Chatbot /> component did catch',
      callParams,
    });
  }

  render() {
    // If we have AI experience the input field should have new design even if you are in critical flow.
    // Because of that we do not need to check first node id(is it AI message or not, like we do in `useIsAiChatbot` hook).
    const { isAiEnabled } = this.props;

    return (
      <DeferredActionEmitter>
        <AttachmentsDropzone chatbotRef={this.chatbotRef}>
          <Box
            ref={this.chatbotRef}
            dataHook="chatbot-app"
            direction="vertical"
            height="100%"
            maxWidth="100%"
            flexGrow="1"
            align="center"
          >
            <Box flexGrow={1} overflow="hidden" direction="vertical" position="relative" width="100%">
              <Chat />
              <ErrorMessages isAiEnabled={isAiEnabled} />
            </Box>
            <Box padding="0 SP2" maxWidth="100%">
              <Box direction="vertical" width="720px" maxWidth="100%">
                {isAiEnabled ? <FieldNext /> : <Field />}
              </Box>
            </Box>
          </Box>
        </AttachmentsDropzone>
        <DocumentVisibilityListener />
      </DeferredActionEmitter>
    );
  }
}

const mapStateToProps = (state: TRootState) => ({
  isAiEnabled: selectIsAiEnabled(state),
});

export default connect(mapStateToProps)(Chatbot);
